// === wizardStepType.js START ====================================================================

wizardSteps["type"] = {
    templateName: "#wizardStepTypeTemplate",
    beforeRender: function (ctx) {
        // This function is called before rendering is done.
        // Model preparation and stuff can be done here.

        var start = undefined;
        if (currentEvent && currentEvent.start)
            start = currentEvent.start;

        // Reset current model
        currentEvent = {};
        ctx.model.o = currentEvent;

        if (start) {
            currentEvent.start = start;
        }
        // Otherwise it'll be injected later

        // type configuration
        ctx.model.onlyMulti = (calendarConfiguration.loginUserType === 'Golf Academy' &&
            $calendar.fullCalendar('getView').type === 'timelineDay' &&
            !currentResource.parent);
        ctx.model.allowAbsence = !ctx.model.onlyMulti && calendarConfiguration.clubPermission === 'Undefined' || calendarConfiguration.clubPermission === 'ClubPermPrivateEdit';
        ctx.model.isCourseCalendar = calendarConfiguration.calendarType === "Courses";

        ctx.model.messages = {
            newAppointment: $t("Neuer Termin"),
            individual: $t("Einzeltraining"),
            course: $t("Kurs / Event"),
            coursePackage: $t("Kurspaket"),
            absence: $t("Abwesenheit / Privat")
        };
    },
    afterPreparation: function (ctx) {
        // Special case for MEs - we proceed to the appointment step instantly
        // Silly way to work around an order of operations issue
        setTimeout(function () {
            if (calendarConfiguration.loginUserType === "Me") {
                currentEvent.appointmentType = "SingleTraining";
                OpenModal("appointment");
            }
        }, 5);
    },
    afterRender: function (ctx) {
        // Events are bound here
        setTimeout(function () {
            ctx.$el.find(".c-icon-button").off('click').on('click', function (e) {
                var btn = $(this);
                currentEvent.appointmentType = btn.data("appointment-type");

                if (currentEvent.appointmentType === "Package") {
                    OpenModal("packageDates");
                } else {
                    OpenModal("appointment");
                }
            });
        }, 250);
    },
    getButtonList: function () {
        return {};
    }
};

// === wizardStepType.js START ====================================================================
